import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import TahunajaranSevice from '../../services/tahunajaranServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('tahunajaran/list', async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await TahunajaranSevice.getList(page, perPage, sort, orderBy, search);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('tahunajaran/getListArchive', async ({ page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await TahunajaranSevice.getListArchive(page, perPage, sort, orderBy, search);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('tahunajaran/create', async ({ name, date_start, date_end, is_active }, thunkAPI) => {
  try {
    const data = {
      name,
      date_start: date_start.format('YYYY-MM-DD'),
      date_end: date_end.format('YYYY-MM-DD'),
      is_active
    };
    const response = await TahunajaranSevice.create(data);
    thunkAPI.dispatch(getList());

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status == 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('tahunajaran/read', async (id, thunkAPI) => {
  try {
    const response = await TahunajaranSevice.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('tahunajaran/update', async ({ id, name, date_start, date_end, is_active }, thunkAPI) => {
  try {
    const data = {
      name,
      date_start: date_start.format('YYYY-MM-DD'),
      date_end: date_end.format('YYYY-MM-DD'),
      is_active
    };
    const response = await TahunajaranSevice.update(id, data);
    thunkAPI.dispatch(getList());

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status == 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('tahunajaran/delete', async (id, thunkAPI) => {
  try {
    const response = await TahunajaranSevice.del(id);
    thunkAPI.dispatch(getList());

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status == 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('tahunajaran/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await TahunajaranSevice.changeStatus(data.id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeActiveStatus = createAsyncThunk('tahunajaran/changeActiveStatus', async (data, thunkAPI) => {
  try {
    const response = await TahunajaranSevice.changeActiveStatus(data.id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [] };

const tahunajaranSlice = createSlice({
  name: 'tahunajaran',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeActiveStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeActiveStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeActiveStatus.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = tahunajaranSlice;
export default reducer;
